/**
 * Набор реализаций интерфейсов для работы с компонентом fui-select библиотеки F-UI Components
 */

import { FuiSelectItemService } from '@fui/fui-components';
import { mbHasMatch } from '@fui/fui-helpers';
import { Observable } from 'rxjs';

/**
 * Структура хелпера для индикации загрузки данных
 */
export interface IDataLoader<TItem> {
    data$: Observable<TItem[]>;
    loading$: Observable<boolean>;
}

/**
 * Пример типа данных элемента списка с полями id=int и name=string
 */
export interface IIdNameItem {
    id: number;
    name: string;
}

/**
 * Пример сервиса элементов списка с полями id=int и name=string
 */
export const defaultIdNameItemService: FuiSelectItemService<IIdNameItem, number> = {
    getKey: (item) => Number(item.id),
    getText: (item) => item.name,
    match: (search, item) => mbHasMatch(item.name, search),
};

/**
 * Пример типа данных элемента списка с полями id=string и name=string
 */
export interface IStringNameItem {
    id: string;
    name: string;
}

/**
 * Пример сервиса элементов списка с полями id=string и name=string
 */
export const defaultStringNameItemService: FuiSelectItemService<IStringNameItem, string> = {
    getKey: (item) => String(item.id),
    getText: (item) => item.name,
    match: (search, item) => mbHasMatch(item.name, search),
};
